import Vue from 'vue';
import Zones from '@/resources/zones';
import normalize from '@/lib/normalize';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'zones';
const DEFAULT_STATE = {
  error: null,
  zones: null,
  zone: null
};

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  mutations: {
    parseZonesResponseData(state, zones) {
      Vue.set(state, 'zones', zones);
    },
    parseZoneResponseData(state, zone) {
      Vue.set(state, 'zone', zone);
    },
    setZone(state, zone) {
      Vue.set(state, 'zone', zone);
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    }
  },
  actions: {
    fetchAll({ commit }, { projectCode }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const action = Zones.get({ code: projectCode });

      action.then(
        response => {
          const zones = normalize(response.data);
          commit('parseZonesResponseData', zones);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return action;
    },
    fetch({ commit }, { projectCode, zoneCode }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const action = Zones.get({ code: projectCode, zoneCode });

      action.then(
        response => {
          const zones = normalize(response.data);
          commit('parseZoneResponseData', zones);

          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return action;
    },
    create({ commit }, { projectCode, data }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const res = Zones.save({ code: projectCode }, data);

      res.then(
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return res;
    },
    remove({ commit }, { projectCode, zoneCode }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const res = Zones.delete({ code: projectCode, zoneCode });

      res.then(
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return res;
    },
    update({ commit }, { projectCode, zoneCode, data }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      const res = Zones.update({ code: projectCode, zoneCode }, data);

      res.then(
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        }
      );

      return res;
    }
  }
};
